

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import reducer from './reducers';

// 🚫 Disable all console logs everywhere
console.log = function () {};
console.warn = function () {};
console.error = function () {};
console.info = function () {};

const store = createStore(reducer, applyMiddleware(thunk))

  
ReactDOM.render(
  <Provider store={store} >
    <App />
  </Provider>
, document.getElementById('root'));

serviceWorker.unregister()
